import { Badge } from '../../../../components/ui';

const STATUS_VARIANTS = {
  APPROVED: 'success',
  PENDING: 'warning',
  PROCESSING: 'info',
  SCHEDULED: 'info',
  QUEUED: 'warning',
  RUNNING: 'info',
  SENT: 'success',
  DONE: 'success',
  DRAFT: 'neutral',
  PAUSED: 'warning',
  FAILED: 'danger',
  REJECTED: 'danger',
  MARKETING: 'info',
  UTILITY: 'success',
  AUTHENTICATION: 'neutral',
  ARCHIVED: 'neutral',
  active: 'success',
  inactive: 'neutral',
};

export default function StatusChip({ value, label }) {
  const normalized = String(value ?? '').toUpperCase();
  const variant = STATUS_VARIANTS[normalized] ?? 'neutral';

  return (
    <Badge variant={variant} size="sm">
      {label ?? value ?? '—'}
    </Badge>
  );
}
